export type { UserMessageProps, UserMessageSlots, UserMessageState } from './components/UserMessage/index';
export {
  UserMessage,
  renderUserMessage_unstable,
  useUserMessageStyles_unstable,
  useUserMessage_unstable,
  userMessageClassNames,
} from './components/UserMessage/index';
